import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables'
import { mq } from '../../helpers'

export const FAQWrapper = styled.section`
  width: 100%;
  background-color: ${gsColors.khaki};
  padding: 72px 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;

  ${mq('max', '800px')} {
    padding: 48px 16px;
    gap: 34px;
  }

  .faq-list {
    width: 100%;
    max-width: 1264px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${mq('max', '800px')} {
      gap: 12px;
    }
  }

  .faq-item {
    position: relative;
    padding: 16px 0 16px 105px;

    ${mq('max', '800px')} {
      padding: 12px 0 12px 48px;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 16px;
      height: 28px;
      width: 1px;
      background: ${gsColors.black};

      ${mq('max', '800px')} {
        top: 12px;
      }
    }
  }

  .faq-item-question {
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    text-align: left;
    cursor: pointer;
    color: ${gsColors.black};
    font-family: Euclid;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.38;
    letter-spacing: 0.2px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    &:focus-visible {
      outline: 2px solid ${gsColors.black};
      outline-offset: 4px;
    }

    ${mq('max', '800px')} {
      font-size: 16px;
      letter-spacing: 0.16px;
    }
  }

  .faq-item-answer {
    color: ${gsColors.black};
    font-family: Euclid;
    font-size: 16px;
    line-height: 1.6;
    margin-top: 0;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease, margin-top 0.3s ease;
  }

  .faq-item.open .faq-item-answer {
    max-height: 1000px;
    margin-top: 16px;
  }

  .faq-item-answer p {
    margin: 0 0 16px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .faq-item a {
    color: ${gsColors.black};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  .faq-see-all {
    ${mq('max', '800px')} {
      font-size: 14px;
      letter-spacing: 1.12px;
      min-width: 0;
      min-height: 48px;
      padding: 14px 50px;
    }
  }
`
